import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Rating, Typography, Box, Alert, CircularProgress
} from '@mui/material';
import { Star } from '@mui/icons-material';
import { astrologerService } from '../../services/api';

const RatingModal = ({ open, onClose, astrologerId, consultationId, astrologerName }) => {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    setRating(0);
    setReview('');
    setError('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!rating) {
      setError('Please select a rating');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await astrologerService.rateAstrologer(astrologerId, {
        consultation_id: consultationId,
        rating,
        review: review.trim()
      });
      handleClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to submit rating');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Rate Your Consultation</DialogTitle>
      <DialogContent>
        {astrologerName && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            How was your session with {astrologerName}?
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
          <Rating
            value={rating}
            onChange={(_, newValue) => setRating(newValue)}
            size="large"
            emptyIcon={<Star style={{ opacity: 0.3 }} fontSize="inherit" />}
          />
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            {rating === 1 && 'Poor'}
            {rating === 2 && 'Fair'}
            {rating === 3 && 'Good'}
            {rating === 4 && 'Very Good'}
            {rating === 5 && 'Excellent'}
          </Typography>
        </Box>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Write a review (optional)"
          value={review}
          onChange={(e) => setReview(e.target.value)}
          sx={{ mt: 1 }}
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>Skip</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !rating}
        >
          {loading ? <CircularProgress size={20} /> : 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RatingModal;
